import _extends from "@babel/runtime/helpers/extends";
import { shuffle } from 'lodash';
import React, { useMemo } from 'react';
import { FIELD_TYPES } from '../../../constants';
import { FieldAnswerFeedbackWUT } from '../../../ui/field-answer-feedback/field-answer-feedback-wut';
import { QuizQuestionWut } from '../../../ui/quiz/quiz-question/quiz-question-wut';
import { CheckboxGroupInputWUT } from '../../../inputs/checkbox-group-input/checkbox-group-input-wut';
import { FieldErrorWUT } from '../../../ui/field-error/field-error-wut';
import { FieldDescriptionWUT } from '../../../ui/field-description/field-description-wut';
import { useFieldAttributes } from '../../../services/field-attributes';
import { getCheckboxGroupError } from '../../../ui/checkbox-group-field/checkbox-group-field-utils';
import { useError } from '../../../field-error';
export const CheckboxGroupField = props => {
  const {
    id,
    target,
    required = true,
    error,
    customErrors,
    description,
    validation,
    FieldLayout,
    label,
    options,
    addOther,
    addOtherLabel,
    addOtherPlaceholder,
    value,
    onFocus,
    onBlur,
    disabled,
    otherInputCharacterLimit,
    numberOfColumns,
    hideBox,
    onChange
  } = props;
  const {
    labelId,
    inputId,
    errorId,
    descriptionId,
    ariaDescribedBy
  } = useFieldAttributes(id, error, description);
  const _error = getCheckboxGroupError(validation, error);
  const {
    hasError,
    errorMessage
  } = useError(_error, customErrors, FIELD_TYPES.QUIZ_MULTI_CHOICE);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => /*#__PURE__*/React.createElement(QuizQuestionWut, {
      labelId: labelId,
      htmlFor: inputId,
      id: props.id,
      error: props.error,
      description: props.description,
      required: required,
      label: props.label,
      hideLabel: props.hideLabel,
      requiredIndicatorType: props.requiredIndicatorType,
      requiredIndicatorPlacement: props.requiredIndicatorPlacement,
      image: props.questionImage,
      imageResize: props.questionImageResize,
      imageAlignment: props.questionImageAlignment,
      imagePlacement: props.questionImagePlacement,
      imageAltText: props.questionImageAltText
    }),
    renderInput: () => /*#__PURE__*/React.createElement(CheckboxGroupInputWUT, {
      label: label,
      options: options,
      addOther: addOther,
      addOtherLabel: addOtherLabel,
      addOtherPlaceholder: addOtherPlaceholder,
      required: required,
      value: value,
      onFocus: onFocus,
      onBlur: onBlur,
      disabled: disabled,
      otherInputCharacterLimit: otherInputCharacterLimit,
      numberOfColumns: numberOfColumns,
      hideBox: hideBox,
      onChange: onChange,
      hasError: hasError,
      inputId: inputId,
      labelId: labelId,
      ariaDescribedBy: ariaDescribedBy
    }),
    renderDescription: () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FieldErrorWUT, {
      target: target,
      hasError: hasError,
      errorMessage: errorMessage,
      id: errorId
    }), /*#__PURE__*/React.createElement(FieldDescriptionWUT, {
      description: description,
      id: descriptionId
    }), /*#__PURE__*/React.createElement(FieldAnswerFeedbackWUT, {
      target: target,
      externalData: props.externalData
    }))
  });
};
function useSortedOptions(randomizeChoices, options) {
  return useMemo(() => randomizeChoices ? shuffle(options) : options, [options, randomizeChoices]);
}
export const QuizMultiChoiceWUT = props => {
  const {
    options,
    randomizeChoices
  } = props;
  const sortedOptions = useSortedOptions(randomizeChoices, options);
  return /*#__PURE__*/React.createElement(CheckboxGroupField, _extends({}, props, {
    options: sortedOptions
  }));
};
//# sourceMappingURL=quiz-multi-choice-wut.js.map